import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dace7f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ConnectionState__icon fas fa-wifi" }, null, -1))
const _hoisted_2 = { class: "ConnectionState__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ConnectionState", { 'ConnectionState--error': !_ctx.isConnected, 'ConnectionState--hidden': _ctx.is_hidden }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text), 1)
  ], 2))
}